import { useState, useEffect } from 'react';

const ChatService = () => {
  const [sessionId, setSessionId] = useState(null);

  useEffect(() => {
    setSessionId(generateUUID());
  }, []);

  const fetchChatbotResponse = async (userQuery, chatHistory) => {
    const response = await fetch('https://chatbotv215-v2-3uqjrnxcpa-uc.a.run.app/query_blog', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
      },
      body: JSON.stringify({
        'input': userQuery,
        'chat_history': chatHistory,
        'session_id': sessionId,
      }),
    });

    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      throw new Error('An error occurred while fetching the chatbot response.');
    }
  };

  const generateUUID = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.floor(Math.random() * 16);
      var v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  };

  return { fetchChatbotResponse };
};

export default ChatService;